// extracted by mini-css-extract-plugin
module.exports = {"glazing":"FacilityCard_glazing__2bH6l","glaze":"FacilityCard_glaze__3GkFt"};